import React from "react";
import styled from "styled-components";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getContextOptions } from "state/clusterprofile/selectors/filters";
import {
  getEnvironments,
  CLUSTER_PROFILE_TYPES,
  FIPS_TYPES,
} from "utils/constants";
import { Blocks } from "modules/list";
import Filters, {
  SelectFieldWrap,
  InputFieldWrap,
} from "components/styled/Filters";

const LabelWrap = styled.div`
  display: flex;
  align-items: center;

  > img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
    max-width: 25px;
  }
`;

function FiltersForm({
  displayedFields = ["search", "cloudTypes", "profileTypes"],
  hiddenProfileTypes = [],
  top,
}) {
  const { t } = useTranslation();
  const contextOptions = useSelector(getContextOptions);
  const ENVIRONMENTS = useSelector(getEnvironments);
  const cloudTypesOptions = ENVIRONMENTS.filter(
    (env) => env.apiKey !== "openshift" && !env.disabled && !env.hideAsOption
  ).map((env) => ({
    label: (
      <LabelWrap>
        <img src={env.smallLogoPath} alt={env.name} />
        <span>{env.name}</span>
      </LabelWrap>
    ),
    value: env.apiKey,
  }));

  return (
    <Filters.FormWrap top={top}>
      {displayedFields.includes("search") && (
        <InputFieldWrap secondary>
          <Blocks.FilterFields.Input
            data-qa="search-filter"
            name="search"
            placeholder={t("Filter by name")}
            allowClear
            searchPrefix
          />
        </InputFieldWrap>
      )}

      {displayedFields.includes("cloudTypes") && (
        <SelectFieldWrap>
          <Blocks.FilterFields.Select
            name="cloudTypes"
            data-qa="cloud-types"
            options={cloudTypesOptions}
            placeholder={t("All")}
            label={t("Cloud Types")}
            mode="multiple"
            showSearch={false}
            maxTagCount={1}
            filterOption={false}
            showArrow
            allowClear
          />
        </SelectFieldWrap>
      )}

      {displayedFields.includes("profileTypes") && (
        <SelectFieldWrap>
          <Blocks.FilterFields.Select
            name="profileTypes"
            data-qa="profile-types"
            options={CLUSTER_PROFILE_TYPES.filter(
              (profileType) => !hiddenProfileTypes.includes(profileType.value)
            )}
            placeholder={t("All")}
            label={t("Profile Types")}
            mode="multiple"
            showSearch={false}
            maxTagCount={1}
            filterOption={false}
            showArrow
            allowClear
          />
        </SelectFieldWrap>
      )}
      {displayedFields.includes("context") && (
        <SelectFieldWrap>
          <Blocks.FilterFields.Select
            name="context"
            data-qa="profile-contexts"
            options={contextOptions}
            placeholder={t("All")}
            label={t("Scope")}
            showSearch={false}
            maxTagCount={1}
            filterOption={false}
            showArrow
            allowClear
          />
        </SelectFieldWrap>
      )}
      {displayedFields.includes("fips") && (
        <SelectFieldWrap>
          <Blocks.FilterFields.Select
            name="fips"
            data-qa="profile-fips"
            options={FIPS_TYPES}
            placeholder={t("All")}
            label={t("FIPS")}
            showSearch={false}
            maxTagCount={1}
            filterOption={false}
            showArrow
            allowClear
          />
        </SelectFieldWrap>
      )}
    </Filters.FormWrap>
  );
}

export default FiltersForm;
